import { render, staticRenderFns } from "./AddNewAvoirModal1.vue?vue&type=template&id=1fd9852b&"
import script from "./AddNewAvoirModal1.vue?vue&type=script&lang=js&"
export * from "./AddNewAvoirModal1.vue?vue&type=script&lang=js&"
import style0 from "./AddNewAvoirModal1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports